<template>

  <div class="mt-2">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span v-if="simulationLot.name && simulationLot.name != ''" class="section-title">{{ $t('SimulationLot') }} {{ simulationLot.name }}</span>
        <span v-else class="section-title">{{ $t('SimulationLot') }} {{ lotNumber }}</span>
        <copy-icon  class="main-red-color trashIcon ml-2" size="16" @click="duplicateSimulationLot"/>
        <trash-icon v-if="deletable" class="main-red-color trashIcon ml-2" size="16" @click="removeSimulationLot"/>
      </div>
    </div>

    <div class="row mt-2">

      <div class="col-md-6">
        <b-form-group
            :label="$t('simulationLot.Name')"
            class="medium-label mb-4"
            label-for="name-input">
          <b-form-input
              id="name-input"
              v-model="simulationLot.name"
              maxlength="250"
              required
              type="text"
              @change="emitChangeValue">
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-2">
        <b-form-group
            :label="$t('simulationLot.Surface')"
            class="medium-label mb-4"
            label-for="surface-input">
          <b-input-group>
            <b-form-input
                id="surface-input"
                v-model="simulationLot.surface"
                v-disable-scroll
                min="0"
                required
                step="0.01"
                type="number"
                @change="emitChangeValue(); updateValues('surface');">
            </b-form-input>
            <b-input-group-append>m²</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-2">
        <b-form-group
            :label="$t('simulationLot.PrixParM2')"
            class="medium-label mb-4"
            label-for="prixParM2-input">
          <b-input-group>
            <b-form-input
                id="prixParM2-input"
                v-model="simulationLot.prixParM2"
                v-disable-scroll
                min="0"
                required
                step=any
                type="number"
                @change="emitChangeValue(); updateValues('prixParM2');">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-md-2">
        <b-form-group
            :label="$t('simulationLot.PrixVenteTTC')"
            class="medium-label mb-4"
            label-for="prixVenteTTC-input">
          <b-input-group>
            <b-form-input
                id="prixVenteTTC-input"
                v-model="simulationLot.prixVenteTTC"
                v-disable-scroll
                min="0"
                required
                step=any
                type="number"
                @change="emitChangeValue(); updateValues('prixVenteTTC');">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6">
        <b-form-group
            :label="$t('simulationLot.TypeLot')"
            class="medium-label mb-4"
            label-for="typeLot-input">
          <custom-tva-select
            id="typeLot-input"
            v-model="simulationLot.typeLot.value"
            :state="simulationLot.typeLot.state"
            required
            v-on:change="emitChangeValue"
            :options="typesLot">
          </custom-tva-select>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
            :label="$t('simulationLot.TypeTVA')"
            class="medium-label mb-4"
            label-for="typeTVA">
          <div id="typeTVA">{{ typeTVA }}</div>
        </b-form-group>
      </div>

    </div>

    <div class="row">
      <div class="col-md-12">
        <b-form-checkbox
          v-model="simulationLot.isLoue"
          @change="handleIsLoueChange"
          class="mb-4">
          {{ $t('simulationLot.AcheteLoue') }}
        </b-form-checkbox>
      </div>
    </div>

    <div v-if="simulationLot.isLoue" class="row">
      <div class="col-auto">
        <b-form-group
          :label="$t('simulationLot.DureeBail')"
          :label-for="`duree-bail-${lotNumber}`"
          class="medium-label">
          <b-input-group>
            <b-form-input
              :id="`duree-bail-${lotNumber}`"
              v-model="simulationLot.dureeBail"
              v-disable-scroll
              min="0"
              required
              type="number"
              @change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>mois</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-auto">
        <b-form-group
            :label="$t('simulationLot.LoyersPercus')"
            class="medium-label mb-4"
            label-for="loyers-percus">
          <b-input-group class="w-auto">
            <b-form-input
                id="loyers-percus"
                v-model="simulationLot.loyersPercus"
                v-disable-scroll
                min="0"
                step="0.01"
                type="number"
                class="w-auto"
                required
                @change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>€</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col-auto">
        <b-form-group
            :label="$t('chargePro.Value.TVA')"
            class="medium-label mb-4"
            label-for="taux-tva">
          <b-input-group class="w-auto">
            <b-form-input
                id="taux-tva"
                v-model="simulationLot.tauxTVA"
                v-disable-scroll
                min="0"
                max="100"
                step="0.01"
                type="number"
                class="w-auto"
                required
                @change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>%</b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </div>

  </div>

</template>

<script>
import customTvaSelect from "../../../components/CustomTvaSelect";
export default {

  name: "SimulationLotComponent",

  components: {
    customTvaSelect
  },

  props: {
    simulationLot: {
      type: Object,
      default: null
    },
    lotNumber: {
      type: Number,
      default: 1
    },
    deletable: {
      type: Boolean,
      default: true
    },
    typesLot: {
      type: Array,
      default() {
        return []
      }
    },
    TVATypes: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {}
  },

  computed: {

    typeTVA() {
      return this.simulationLot.typeLot.value ? this.$i18n.t(this.typesLot.find(typeLot => typeLot.value === this.simulationLot.typeLot.value).text + ".labelTVA") : ''
    },



  },

  emits: ['removedSimulationLot', 'didChangeValue'],

  methods: {

    removeSimulationLot() {
      this.$emit('removedSimulationLot', this.simulationLot)
    },

    duplicateSimulationLot() {
      this.$emit('duplicateSimulationLot', this.simulationLot)
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    handleIsLoueChange() {
      if (!this.simulationLot.isLoue) {
        this.simulationLot.dureeBail = null;
        this.simulationLot.loyersPercus = null;
        this.simulationLot.tauxTVA = null;
      }
      this.emitChangeValue();
    },

    updateValues(modified) {
      switch (modified) {
        case 'surface' :
          if (this.simulationLot.prixParM2) {
            this.simulationLot.prixVenteTTC = Number(this.simulationLot.surface * this.simulationLot.prixParM2).toFixed(2)
          } else if (this.simulationLot.prixVenteTTC) {
            this.simulationLot.prixParM2 = Number(this.simulationLot.prixVenteTTC / this.simulationLot.surface).toFixed(2)
          } else {
            this.simulationLot.prixVenteTTC = 0
          }
          break;
        case 'prixParM2' :
          if (this.simulationLot.surface) {
            this.simulationLot.prixVenteTTC = Number(this.simulationLot.surface * this.simulationLot.prixParM2).toFixed(2)
          } else {
            this.simulationLot.prixVenteTTC = 0
          }
          break;
        case 'prixVenteTTC':
          if (this.simulationLot.surface) {
            this.simulationLot.prixParM2 = Number(this.simulationLot.prixVenteTTC / this.simulationLot.surface).toFixed(2)
          } else {
            this.simulationLot.prixParM2 = 0
          }
          break;
        default:
          break;
      }
    }
  }

}

</script>

<style scoped>

#typeTVA {
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #EAEDF4;
}

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/SimulationLotComponent.vue